import React, { useMemo } from 'react'

import { formatOccupantsShort } from 'lib/offer/occupancyUtils'
import { min } from 'lib/arrayUtils'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import TextButton from 'components/Luxkit/Button/TextButton'

import BaseDeparturesMessagePane, { DeparturesMessagePaneActionContainer, DeparturesMessagePaneTitleContainer } from './BaseDeparturesMessagePane'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'

const ADULT_AGE_CUTOFF = 18

interface MappedStateProps {
  occupancies: App.Occupants[]
}
interface Props {
  minChildPriceAge: number
  onUpdateTravellersClick: () => void
}

function InvalidTravellersMessagePane(props: Props & MappedStateProps) {
  const {
    minChildPriceAge,
    occupancies,
    onUpdateTravellersClick,
  } = props

  const {
    bodyText,
    headingText,
  } = useMemo(
    () => {
      let headingText = 'No departures available'
      let bodyText = null

      if (occupancies?.length) {
        for (const occupants of occupancies) {
          if (occupants.children && occupants.childrenAge) {
            const minChildAge = min(occupants.childrenAge)
            if (minChildAge < minChildPriceAge) {
              headingText = minChildPriceAge === ADULT_AGE_CUTOFF ?
                'Oops! Looks like this tour is exclusive to adults.' :
              `No departure dates available, the minimum age for this tour is ${minChildPriceAge}.`
            }
          }
        }
        bodyText = `There are no departures matching your traveller selection of ${formatOccupantsShort(occupancies)}.`
      }

      return {
        bodyText,
        headingText,
      }
    },
    [minChildPriceAge, occupancies],
  )

  return <BaseDeparturesMessagePane>
    <DeparturesMessagePaneTitleContainer>
      <Heading variant="heading6">{headingText}</Heading>
      <BodyText variant="large">{bodyText}</BodyText>
    </DeparturesMessagePaneTitleContainer>

    <DeparturesMessagePaneActionContainer>
      <TextButton kind="primary" fit="mobile-full-width" onClick={onUpdateTravellersClick}>
        Update travellers
      </TextButton>
    </DeparturesMessagePaneActionContainer>
  </BaseDeparturesMessagePane>
}

export default withOfferPageState<MappedStateProps>(offerPageState => ({
  occupancies: offerPageState.rooms,
}))(InvalidTravellersMessagePane)
